export const queryParam = (name: string, defaultValue: string) => {
    const params = new URLSearchParams(window.location.search);
    return params.get(name) || defaultValue;
};

type PrettySizeProps = {
    size: number; // The number to pretty print
    nospace?: boolean; // Don't print a space
    one?: boolean; // Only print one character
    places?: number; // Number of decimal places to return
    numOnly?: boolean; // Return only the converted number and not size string
};

export const prettySize = ({ size, nospace = false, one = false, places = 1, numOnly = false }: PrettySizeProps) => {
    const sizes = ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB'];

    var mysize;

    for (let id = 0; id < sizes.length; ++id) {
        let unit = sizes[id];

        if (one) unit = unit.slice(0, 1);

        const s = Math.pow(1024, id);
        let fixed;
        if (size >= s) {
            fixed = String((size / s).toFixed(places));
            if (fixed.indexOf('.0') === fixed.length - 2) {
                fixed = fixed.slice(0, -2);
            }
            mysize = fixed + (nospace ? '' : ' ') + unit;
        }
    }

    // zero handling
    // always prints in Bytes
    if (!mysize) {
        const _unit = one ? sizes[0].slice(0, 1) : sizes[0];
        mysize = '0' + (nospace ? '' : ' ') + _unit;
    }

    if (numOnly) {
        mysize = Number.parseFloat(mysize);
    }

    return mysize;
};
